/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StorageNodeMini,
    StorageNodeMiniFromJSON,
    StorageNodeMiniFromJSONTyped,
    StorageNodeMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface LizardFSNode
 */
export interface LizardFSNode {
    /**
     * 
     * @type {StorageNodeMini}
     * @memberof LizardFSNode
     */
    node?: StorageNodeMini | null;
    /**
     * 
     * @type {string}
     * @memberof LizardFSNode
     */
    host: string;
    /**
     * 
     * @type {boolean}
     * @memberof LizardFSNode
     */
    online: boolean;
    /**
     * 
     * @type {string}
     * @memberof LizardFSNode
     */
    version: string;
    /**
     * 
     * @type {number}
     * @memberof LizardFSNode
     */
    chunks: number;
    /**
     * 
     * @type {number}
     * @memberof LizardFSNode
     */
    sizeTotal: number;
    /**
     * 
     * @type {number}
     * @memberof LizardFSNode
     */
    sizeUsed: number;
    /**
     * 
     * @type {number}
     * @memberof LizardFSNode
     */
    sizeFree: number;
    /**
     * 
     * @type {number}
     * @memberof LizardFSNode
     */
    chunksForRemoval: number;
    /**
     * 
     * @type {string}
     * @memberof LizardFSNode
     */
    label: string;
}

export function LizardFSNodeFromJSON(json: any): LizardFSNode {
    return LizardFSNodeFromJSONTyped(json, false);
}

export function LizardFSNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LizardFSNode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'node': !exists(json, 'node') ? undefined : StorageNodeMiniFromJSON(json['node']),
        'host': json['host'],
        'online': json['online'],
        'version': json['version'],
        'chunks': json['chunks'],
        'sizeTotal': json['size_total'],
        'sizeUsed': json['size_used'],
        'sizeFree': json['size_free'],
        'chunksForRemoval': json['chunks_for_removal'],
        'label': json['label'],
    };
}

export function LizardFSNodeToJSON(value?: LizardFSNode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'node': StorageNodeMiniToJSON(value.node),
        'host': value.host,
        'online': value.online,
        'version': value.version,
        'chunks': value.chunks,
        'size_total': value.sizeTotal,
        'size_used': value.sizeUsed,
        'size_free': value.sizeFree,
        'chunks_for_removal': value.chunksForRemoval,
        'label': value.label,
    };
}


